export default {
  "editRule": "Edit Rule",
  "addGeoLockRule": "Add Geo-Lock Rule",
  "close": "Close",
  "name": "Name",
  "eGUSOnlyAccess": "e.g. US-only access",
  "description": "Description",
  "optional": "(optional)",
  "optionalDescriptionOfThisRule": "Optional description of this rule",
  "serverType": "Server Type",
  "all": "All",
  "action": "Action",
  "gracePeriodSeconds": "Grace Period (seconds)",
  "leaveEmptyForGlobalDefault": "(leave empty for global default)",
  "45GlobalDefault": "45 (global default)",
  "username": "Username",
  "deviceID": "Device ID",
  "allowedGeography": "Allowed Geography",
  "countries": "Countries",
  "searchAndAddCountries": "Search and add countries",
  "regions": "Regions",
  "commaSeparated": "(comma-separated)",
  "cities": "Cities",
  "iPRanges": "IP Ranges",
  "cIDRFormatCommaSeparated": "(CIDR format, comma-separated)",
  "firewallAutoBlock": "Firewall Auto-Block",
  "blockIPAtFirewallAfterGraceExpires": "Block IP at firewall after grace expires",
  "blockDurationSeconds": "Block Duration (seconds)",
  "default1Hour3600sMax24Hours": "Default: 1 hour (3600s). Max: 24 hours.",
  "bypassPrivateIPs": "Bypass private IPs",
  "enabled": "Enabled",
  "cancel": "Cancel",
  "saveChanges": "Save Changes",
  "createRule": "Create Rule",
  "completedThreshold": "Completed Threshold",
  "sessionsReachingThisCompletionAreCountedAsCompleted": "Sessions reaching this completion % are counted as completed",
  "abandonedThreshold": "Abandoned Threshold",
  "sessionsBelowThisCompletionAreClassifiedAsAbandoned": "Sessions below this completion % are classified as abandoned",
  "minWatchTime": "Min Watch Time",
  "sessionsShorterThanThisAreExcludedFromAnalytics0": "Sessions shorter than this are excluded from analytics (0 to disable)",
  "missingCycles": "Missing Cycles",
  "pollCyclesBeforeADisappearedSessionIsFinalizedEach": "Poll cycles before a disappeared session is finalized (each cycle ≈ 5s)",
  "analytics": "Analytics",
  "configureHowStreamingSessionsAreClassifiedInAnalyticsThese": "Configure how streaming sessions are classified in analytics. These thresholds determine when a session counts as completed, abandoned, or excluded from statistics.",
  "excludedUsers": "Excluded Users",
  "sessionsFromTheseMediaServerUsersWillBeExcluded": "Sessions from these media server users will be excluded from all analytics and intelligence metrics. Use this to filter out test accounts or admin activity that skews results.",
  "searchUsersToExclude": "Search users to exclude...",
  "excludedAnalyticsUsers": "Excluded analytics users",
  "analyticsTimeRange": "Analytics Time Range",
  "globalTimeWindowAppliedToAllAnalyticsAndIntelligence": "Global time window applied to all analytics and intelligence views. Controls how far back data is included in dashboards.",
  "allTime": "All Time",
  "customDays": "Custom days...",
  "customTimeRangeInDays": "Custom time range in days",
  "days": "days",
  "allHistoricalDataIncluded": "All historical data included",
  "dataRetention": "Data Retention",
  "controlsHowLongWatchSessionDataIsStoredSessions": "Controls how long watch session data is stored. Sessions older than this are automatically deleted. Set to ‘Disabled’ to keep all data.",
  "dataRetentionIsDisabledWhenDisplayRangeIsSet": "Data retention is disabled when display range is set to All Time",
  "disabled": "Disabled",
  "customRetentionPeriodInDays": "Custom retention period in days",
  "dataKeptForever": "Data kept forever",
  "retentionPeriodIsShorterThanDisplayRangeSomeDisplayable": "Retention period is shorter than display range — some displayable data will be deleted",
  "abandonedThresholdMustBeLessThanCompletedThreshold": "Abandoned threshold must be less than completed threshold",
  "saveAnalytics": "Save Analytics",
  "historicalImport": "Historical Import",
  "resetAnalytics": "Reset Analytics",
  "permanentlyDeleteAllWatchSessionHistoryIncludingBothLive": "Permanently delete all watch session history, including both live-tracked and imported data. Use this to start fresh before a new bootstrap import. This action cannot be undone.",
  "resetAllAnalyticsData": "Reset all analytics data",
  "thisWillPermanentlyDeleteALLWatchSessionHistoryIncluding": "This will permanently delete ALL watch session history including both live-tracked and imported data. This action cannot be undone.",
  "resetAllData": "Reset All Data",
  "noneServerArtwork": "None (server artwork)",
  "customKeyConfigured": "Custom key configured",
  "builtInKeyActive": "Built-in key active",
  "test": "Test",
  "clear": "Clear",
  "tMDBAPIKeyIsValid": "TMDB API key is valid",
  "tMDBAPIKeyTestFailed": "TMDB API key test failed",
  "theTVDBAPIKeyIsValid": "TheTVDB API key is valid",
  "theTVDBAPIKeyTestFailed": "TheTVDB API key test failed",
  "tMDBCoverArt": "TMDB Cover Art",
  "highQualityCanonicalCoverArtFromTheMovieDatabase": "High-quality canonical cover art from The Movie Database.",
  "enableTMDBCoverArt": "Enable TMDB cover art",
  "theTVDBCoverArt": "TheTVDB Cover Art",
  "communityCuratedArtworkFromTheTVDBIdealForTVSeries": "Community-curated artwork from TheTVDB, ideal for TV series.",
  "enableTheTVDBCoverArt": "Enable TheTVDB cover art",
  "providerRouting": "Provider Routing",
  "chooseWhichProviderSuppliesArtworkForEachContentCategory": "Choose which provider supplies artwork for each content category.",
  "movieLibraries": "Movie Libraries",
  "seriesLibraries": "Series Libraries",
  "tMDBAPIKeyOptional": "TMDB API Key (Optional)",
  "provideYourOwnTMDBAPIKeyForDedicatedRate": "Provide your own TMDB API key for dedicated rate limits. Leave empty to use the built-in key.",
  "theTVDBAPIKeyOptional": "TheTVDB API Key (Optional)",
  "provideYourOwnTheTVDBAPIKeyForDedicatedRate": "Provide your own TheTVDB API key for dedicated rate limits. Leave empty to use the built-in key.",
  "manualKey": "Manual key",
  "auto": "Auto",
  "aPIKeyOverrideOptional": "API Key Override (Optional)",
  "aBoxLevelKeyIsSetAndUsedFor": "A box-level key is set and used for every instance. Leave blank to keep it, or clear to return to per-user auto-discovery.",
  "leaveBlankToAutoDiscoverEachUserSKey": "Leave blank to auto-discover each user's key from disk. Set one to override every instance with a single box-level key.",
  "noKeyDiscovered": "No key discovered",
  "manualKeyConfigured": "Manual key configured",
  "autoDiscoveredFromDisk": "Auto-discovered from disk",
  "hideKey": "Hide key",
  "revealEffectiveKey": "Reveal effective key",
  "linkbackURL": "Linkback URL",
  "externalURL": "External URL",
  "dialOverrideForAnInstallAutoDiscoveryCannotReach": "Dial override for an install auto-discovery cannot reach.",
  "mediaRequests": "Media Requests",
  "off": "Off",
  "enableMediaRequests": "Enable Media Requests",
  "showAndActOnOmbiAndSeerrRequestsFrom": "Show and act on Ombi and Seerr requests from the dashboard.",
  "enableMediaRequests2": "Enable media requests",
  "displayOptions": "Display Options",
  "defaultView": "Default View",
  "allRequests": "All requests",
  "pending": "Pending",
  "approved": "Approved",
  "theTabTheRequestsListOpensOn": "The tab the requests list opens on.",
  "inLibraryPageSize": "In-Library Page Size",
  "sendAnnouncement": "Send Announcement",
  "enterTheMessageToSendToAllActiveSessions": "Enter the message to send to all active sessions",
  "enterAnnouncementMessage": "Enter announcement message...",
  "send": "Send",
  "notifications": "Notifications",
  "custom": "Custom",
  "configureTheDefaultSubjectLineAndMessageTemplateFor": "Configure the default subject line and message template for notifications sent to media server sessions.",
  "defaultSubject": "Default Subject",
  "defaultMessageSubject": "Default message subject",
  "defaultMessageTemplate": "Default Message Template",
  "enterADefaultMessageTemplateOptional": "Enter a default message template (optional)",
  "defaultMessageTemplate2": "Default message template",
  "optionalDefaultMessageBodyWhenSetMassAnnouncementsWill": "Optional default message body. When set, mass announcements will use this template unless overridden.",
  "saveSettings": "Save Settings",
  "massAnnouncement": "Mass Announcement",
  "sendAMessageToAllCurrentlyActiveStreamingSessions": "Send a message to all currently active streaming sessions at once.",
  "useCustomSubjectForAnnouncement": "Use custom subject for announcement",
  "customAnnouncementSubject": "Custom announcement subject...",
  "customAnnouncementSubject2": "Custom announcement subject",
  "announcementMessage": "Announcement message",
  "leaveEmptyToUseTheDefaultTemplateAbove": "Leave empty to use the default template above.",
  "sendsToAllActiveSessionsAcrossAllConfiguredServers": "Sends to all active sessions across all configured servers.",
  "sendToAll": "Send to All",
  "movies": "Movies",
  "tVShows": "TV Shows",
  "liveTV": "Live TV",
  "warningAfter": "Warning after",
  "stopAfter": "Stop after",
  "warningMustBeLessThanStop": "Warning must be less than stop",
  "pauseRules": "Pause Rules",
  "active": "Active",
  "automaticallyWarnAndStopPausedSessionsAfterConfigurableThresholds": "Automatically warn and stop paused sessions after configurable thresholds. Set a threshold to 0 to disable that action for a media type.",
  "enablePauseRules": "Enable Pause Rules",
  "monitorPausedSessionsAndTakeActionWhenThresholdsAre": "Monitor paused sessions and take action when thresholds are exceeded",
  "enablePauseRules2": "Enable pause rules",
  "thresholdsSeconds": "Thresholds (seconds)",
  "warningNoticeTemplate": "Warning Notice Template",
  "warningNoticeMessageTemplate": "Warning notice message template",
  "placeholders": "Placeholders:",
  "stopMessage": "Stop Message",
  "sentToTheUserSDeviceBeforeStoppingA": "Sent to the user's device before stopping a paused session. The message wakes sleeping devices and gives users a chance to resume.",
  "header": "Header",
  "siteTitleDefault": "Site title (default)",
  "stopMessageHeader": "Stop message header",
  "stopMessageText": "Stop message text",
  "savePauseRules": "Save Pause Rules",
  "boundToADVRAndServingLiveTVChannels": "Bound to a DVR and serving Live TV channels.",
  "staged": "Staged",
  "registeredAndReachableButNotYetBoundToA": "Registered and reachable, but not yet bound to a DVR.",
  "orphaned": "Orphaned",
  "registeredButUnreachableDeadSafeToRemove": "Registered but unreachable (dead). Safe to remove.",
  "justNow": "just now",
  "concurrentStreamCapacityIsNotReportedForThisTuner": "Concurrent-stream capacity is not reported for this tuner.",
  "liveConcurrentStreamsVsTheMaximumSimultaneousStreamsThis": "Live concurrent streams vs the maximum simultaneous streams this tuner can serve.",
  "tunerDisplayAlias": "Tuner display alias",
  "saveAlias": "Save alias",
  "cancelAliasEdit": "Cancel alias edit",
  "max": "Max",
  "characters": "characters",
  "plexTitle": "Plex title:",
  "dead": "Dead",
  "alive": "Alive",
  "plexModel": "Plex model:",
  "seen": "Seen",
  "disableThisTunerWithoutRemovingIt": "Disable this tuner without removing it",
  "enableThisTuner": "Enable this tuner",
  "removeActivePlexTuner": "Remove active Plex tuner?",
  "removePlexTuner": "Remove Plex tuner",
  "remove": "Remove",
  "removeActiveTuner": "Remove active tuner",
  "plexTuners": "Plex Tuners",
  "managePlexLiveTVTunerDevicesGrabbersEachRow": "Manage Plex Live TV tuner devices (grabbers). Each row shows live concurrent-stream usage against the tuner’s capacity. Active tuners are bound to a DVR, staged tuners are registered but not yet bound, and orphaned tuners are unreachable. Use the pencil on the title to rename the tuner, or the pencil on the model line to rename the device (local display names only — neither changes anything in Plex).",
  "refreshPlexTuners": "Refresh Plex tuners",
  "refresh": "Refresh",
  "tryAgain": "Try again",
  "noPlexTunersDetected": "No Plex tuners detected.",
  "loadingTuners": "Loading tuners...",
  "noTunerHostsAvailableEnsureMediaServersAreConfigured": "No tuner hosts available. Ensure media servers are configured and have Live TV tuners.",
  "noTunerHostsFoundOnConfiguredServers": "No tuner hosts found on configured servers.",
  "lIVE": "LIVE",
  "editSource": "Edit Source",
  "newSource": "New Source",
  "label": "Label",
  "sourceLabel": "Source label",
  "serverTypeFilter": "Server type filter",
  "allServers": "All Servers",
  "badgeColor": "Badge Color",
  "selectAColor": "Select a color",
  "badgeColor2": "Badge color",
  "enableSource": "Enable source",
  "tunerHosts": "Tuner Hosts",
  "refreshTunerList": "Refresh tuner list",
  "updateSource": "Update Source",
  "createSource": "Create Source",
  "deleteStreamSource": "Delete Stream Source",
  "delete": "Delete",
  "liveTVSources": "Live TV Sources",
  "mapLiveTVTunerHostsToFriendlyLabelsWhen": "Map Live TV tuner hosts to friendly labels. When a session uses a matched tuner, the source label is shown as a badge in the streaming dashboard.",
  "noStreamSourcesConfiguredAddOneToStartLabeling": "No stream sources configured. Add one to start labeling Live TV sessions.",
  "addSource": "Add Source",
  "configureMediaServerConnectionsForSessionMonitoring": "Configure media server connections for session monitoring",
  "streamingSettings": "Streaming Settings",
  "connectionSettings": "Connection Settings",
  "enableStreamingDashboard": "Enable Streaming Dashboard",
  "monitorActiveStreamingSessionsFromEmbyJellyfinAndPlex": "Monitor active streaming sessions from Emby, Jellyfin, and Plex",
  "enableStreamingDashboard2": "Enable streaming dashboard",
  "pollIntervalMs": "Poll Interval (ms)",
  "200060000ms": "2000-60000ms",
  "geoIPLookups": "GeoIP Lookups",
  "enableGeoIPLookups": "Enable GeoIP lookups",
  "showCountryFlags": "Show country flags",
  "disableToStopMonitoringEmbySessionsWithoutRemovingYour": "Disable to stop monitoring Emby sessions without removing your configuration",
  "enableToStartMonitoringActiveEmbySessions": "Enable to start monitoring active Emby sessions",
  "enableEmbyConnection": "Enable Emby connection",
  "oK": "OK",
  "serverURL": "Server URL",
  "aPIKey": "API Key",
  "enterAPIKey": "Enter API key",
  "externalLink": "External Link",
  "disableToStopMonitoringPlexSessionsWithoutRemovingYour": "Disable to stop monitoring Plex sessions without removing your configuration",
  "enableToStartMonitoringActivePlexSessions": "Enable to start monitoring active Plex sessions",
  "enablePlexConnection": "Enable Plex connection",
  "xPlexToken": "X-Plex-Token",
  "enterXPlexToken": "Enter X-Plex-Token",
  "disableToStopMonitoringJellyfinSessionsWithoutRemovingYour": "Disable to stop monitoring Jellyfin sessions without removing your configuration",
  "enableToStartMonitoringActiveJellyfinSessions": "Enable to start monitoring active Jellyfin sessions",
  "enableJellyfinConnection": "Enable Jellyfin connection",
  "plexLiveTVGuideDispatcharr": "Plex Live TV Guide (Dispatcharr)",
  "configured": "Configured",
  "optional2": "Optional",
  "correctsPlexSLiveTVGuideWhenYourChannels": "Corrects Plex’s Live TV guide when your channels come from Dispatcharr. Plex-only — Emby and Jellyfin read Dispatcharr’s guide directly, so they don’t need this. Paste the Dispatcharr Base URL and an API key generated in Dispatcharr (Settings → API Keys) to show the correct channel and program. Leave blank to use Plex’s built-in guide. On QuickBox Dispatcharr installs this is provisioned automatically.",
  "baseURL": "Base URL",
  "leaveBlankToKeep": "•••••••• (leave blank to keep)",
  "aKeyIsStoredTypeANewKeyTo": "A key is stored. Type a new key to replace it, or clear the Base URL to disable the EPG override.",
  "writeOnlyTheStoredKeyIsNeverShown": "Write-only. The stored key is never shown.",
  "channelMapRepair": "Channel map repair",
  "fixesPlexTuningTheWrongLiveTVChannelAfter": "Fixes Plex tuning the wrong Live TV channel after the Dispatcharr lineup changes. Always previews the changes first — nothing is written until you apply.",
  "reSyncPlexChannelMap": "Re-sync Plex channel map",
  "signInToReSyncYourChannelMap": "Sign in to re-sync your channel map",
  "channelMapIsCorrectNoChangesWereNeeded": "Channel map is correct. No changes were needed.",
  "channelMapIsAlreadyCorrectNothingToFix": "Channel map is already correct — nothing to fix.",
  "done": "Done",
  "backupSaved": " Backup saved.",
  "eachRowShowsAChannelAndTheNumberPlex": "Each row shows a channel and the number Plex will tune (current → corrected).",
  "aBackupOfTheCurrentMapIsTakenAutomatically": "A backup of the current map is taken automatically before any change.",
  "applyFix": "Apply fix",
  "duplicateGuideIDs": "Duplicate guide IDs",
  "findsLiveTVChannelsThatShareTheSameGuide": "Finds Live TV channels that share the same guide id (tvg_id), which makes the EPG show the wrong program. This is a read-only check — fix any matches in Dispatcharr.",
  "checkDuplicateGuideIDs": "Check duplicate guide IDs",
  "signInToCheckForDuplicateGuideIDs": "Sign in to check for duplicate guide IDs",
  "noDuplicateGuideIDsFound": "No duplicate guide IDs found.",
  "eachGroupListsTheSharedGuideIdAndThe": "Each group lists the shared guide id and the channels using it (number — name). Fix these in Dispatcharr.",
  "message": "—",
  "maxAge": "Max age",
  "pathNotReadableOrDoesNotExist": "Path not readable or does not exist",
  "transcodeDirectoryIsEmpty": "Transcode directory is empty",
  "refreshStats": "Refresh stats",
  "refreshTranscodeStats": "Refresh transcode stats",
  "transcodePurge": "Transcode Purge",
  "automaticallyCleanUpStaleTranscodeFilesPerMediaType": "Automatically clean up stale transcode files per media type. Set a max age to 0 to disable purging for that media type.",
  "enableTranscodePurge": "Enable Transcode Purge",
  "periodicallyDeleteOldTranscodeFilesThatExceedTheConfigured": "Periodically delete old transcode files that exceed the configured age limits",
  "enableTranscodePurge2": "Enable transcode purge",
  "noPathConfiguredTheSystemWillAttemptToDetect": "No path configured — the system will attempt to detect the transcode directory from your media server.",
  "purgePath": "Purge Path",
  "transcodePurgeDirectoryPath": "Transcode purge directory path",
  "pathMustBe512CharactersOrLess": "Path must be 512 characters or less",
  "baseDirectoryContainingTranscodeFilesToPurgeIfLeft": "Base directory containing transcode files to purge. If left empty, the system will attempt to auto-detect from your media server.",
  "logsPath": "Logs Path",
  "mediaServerLogsDirectoryPath": "Media server logs directory path",
  "directoryStats": "Directory Stats",
  "loadingDirectoryStats": "Loading directory stats...",
  "maxAgePerMediaTypeMinutes": "Max Age per Media Type (minutes)",
  "safetyControls": "Safety Controls",
  "minAgeBeforeDeleteMinutes": "Min age before delete (minutes)",
  "minimumFileAgeBeforeDeletionInMinutes": "Minimum file age before deletion in minutes",
  "filesYoungerThanThisAreNeverDeleted160": "Files younger than this are never deleted (1-60)",
  "maxDeletesPerRun": "Max deletes per run",
  "maximumFilesToDeletePerPurgeCycle": "Maximum files to delete per purge cycle",
  "limitsHowManyFilesAreRemovedPerCycle1": "Limits how many files are removed per cycle (1-1000)",
  "saveTranscodePurge": "Save Transcode Purge",
  "failedToLoadAnalyticsSettings": "Failed to load analytics settings",
  "failedToUpdateAnalyticsSettings": "Failed to update analytics settings",
  "analyticsSettingsSaved": "Analytics settings saved",
  "failedToLoadCoverArtSettings": "Failed to load cover art settings",
  "failedToUpdateCoverArtSettings": "Failed to update cover art settings",
  "coverArtSettingsSaved": "Cover art settings saved",
  "connectionFailed": "Connection failed",
  "failedToRevealTheKey": "Failed to reveal the key",
  "failedToLoadRequestSettings": "Failed to load request settings",
  "failedToUpdateRequestSettings": "Failed to update request settings",
  "requestSettingsSaved": "Request settings saved",
  "failedToLoadNotificationSettings": "Failed to load notification settings",
  "failedToUpdateNotificationSettings": "Failed to update notification settings",
  "notificationSettingsSaved": "Notification settings saved",
  "failedToSendAnnouncement": "Failed to send announcement",
  "noActiveSessionsToAnnounceTo": "No active sessions to announce to",
  "failedToLoadPauseRuleSettings": "Failed to load pause rule settings",
  "failedToUpdatePauseRuleSettings": "Failed to update pause rule settings",
  "pauseRuleSettingsSaved": "Pause rule settings saved",
  "failedToLoadPlexTuners": "Failed to load Plex tuners",
  "failedToRemovePlexTuner": "Failed to remove Plex tuner",
  "plexTunerRemoved": "Plex tuner removed",
  "failedToUpdatePlexTuner": "Failed to update Plex tuner",
  "plexTunerEnabled": "Plex tuner enabled",
  "plexTunerDisabled": "Plex tuner disabled",
  "failedToSaveTunerAlias": "Failed to save tuner alias",
  "tunerAliasSaved": "Tuner alias saved",
  "failedToClearTunerAlias": "Failed to clear tuner alias",
  "tunerAliasCleared": "Tuner alias cleared",
  "failedToSaveDeviceName": "Failed to save device name",
  "deviceNameSaved": "Device name saved",
  "failedToClearDeviceName": "Failed to clear device name",
  "deviceNameCleared": "Device name cleared",
  "failedToLoadStreamSources": "Failed to load stream sources",
  "failedToFetchTunerHosts": "Failed to fetch tuner hosts",
  "failedToCreateStreamSource": "Failed to create stream source",
  "streamSourceCreated": "Stream source created",
  "failedToUpdateStreamSource": "Failed to update stream source",
  "streamSourceUpdated": "Stream source updated",
  "failedToDeleteStreamSource": "Failed to delete stream source",
  "streamSourceDeleted": "Stream source deleted",
  "failedToLoadTranscodePurgeSettings": "Failed to load transcode purge settings",
  "failedToUpdateTranscodePurgeSettings": "Failed to update transcode purge settings",
  "transcodePurgeSettingsSaved": "Transcode purge settings saved",
  "failedToLoadUserPolicy": "Failed to load user policy",
  "failedToUpdateUserPolicy": "Failed to update user policy",
  "unableToLoadPreferences": "Unable to load preferences.",
  "unableToSavePreferences": "Unable to save preferences.",
  "failedToLoadStreamingSettings": "Failed to load streaming settings",
  "failedToUpdateSettings": "Failed to update settings",
  "streamingSettingsSaved": "Streaming settings saved",
  "connectionTestFailed": "Connection test failed",
  "youDonTHavePermissionToViewGeoLock": "You don't have permission to view geo lock rules.",
  "failedToLoadGeoLockRules": "Failed to load geo lock rules.",
  "failedToCreateRule": "Failed to create rule.",
  "networkError": "Network error.",
  "failedToUpdateRule": "Failed to update rule.",
  "failedToDeleteRule": "Failed to delete rule.",
  "selectCountry": "Select country",
  "selectCountries": "Select countries",
  "removeCountry": "Remove {{country}}",
  "countriesSelected": "Selected: {{count}}",
  "searchCountriesPlaceholder": "Search countries…",
  "searchCountries": "Search countries",
  "noCountriesFound": "No countries found",
  "enableLabelRequests": "Enable {{label}} requests",
  "labelWarningThresholdInSeconds": "{{label}} warning threshold in seconds",
  "labelStopThresholdInSeconds": "{{label}} stop threshold in seconds",
  "clampedCapacityStreamsInUse": "{{clamped}} / {{capacity}} streams in use",
  "renameTunerDisplayName": "Rename tuner {{displayName}}",
  "setADisplayNameForTitle": "Set a display name for {{title}}",
  "renameTunerDeviceDeviceDisplay": "Rename tuner device {{deviceDisplay}}",
  "setADeviceNameForModel": "Set a device name for {{model}}",
  "removeTunerDisplayName": "Remove tuner {{displayName}}",
  "selectTunerDisplayName": "Select tuner {{displayName}}",
  "editLabel": "Edit {{label}}",
  "deleteLabel": "Delete {{label}}",
  "areYouSureYouWantToDeleteLabelThisCannot": "Are you sure you want to delete \"{{label}}\"? This cannot be undone.",
  "tvgIdTunesOldDeviceWillTuneNewDevice": "{{tvgId}}: tunes {{oldDevice}}, will tune {{newDevice}}",
  "channelNumberName": "channel {{number}}, {{name}}",
  "labelMaxTranscodeAgeInMinutes": "{{label}} max transcode age in minutes",
  "sentToSentTotalSessionsFailedFailed": "Sent to {{sent}}/{{total}} sessions ({{failed}} failed)",
  "connectedToServerLabelServerName": "Connected to {{serverLabel}}{{serverName}}",
  "disableTuner": "Disable tuner {{name}}",
  "enableTuner": "Enable tuner {{name}}",
  "removeActiveTunerUnknown": "{{name}} is bound to {{dvr}} and is actively serving live TV channels. Removing it will stop those channels.",
  "removeActiveTunerCount": "{{name}} is bound to {{dvr}} and is actively serving {{count}} live TV channels. Removing it will stop those channels.",
  "removeTunerBody": "Remove {{name}} from Plex? This cannot be undone.",
  "aDvr": "a DVR",
  "subjectDescription": "The header/title shown when sending messages to sessions. Defaults to “{{subject}}” from the instance name.",
  "customSubjectDefault": "Custom subject (otherwise uses “{{subject}}”)",
  "requestPublicUrl": "Public deep-link base used to open a request in {{provider}}.",
  "libraryPageSizeDescription": "How many already-in-library items the list shows per page ({{min}}–{{max}}).",
  "channelsRemapped": "Remapped channels: {{count}}.",
  "guideReloaded": "The guide was reloaded.",
  "channelsToRemap": "Channels to remap: {{count}}.",
  "duplicateGuideIds": "Shared guide IDs: {{ids}}. Affected channels: {{channels}}.",
  "transcodeBreakdown": "(Standard: {{standard}}; live TV: {{live}})",
  "purgedAt": "Purged {{time}}",
  "selectedDays": "Selected days: {{count}}",
  "egJohn": "e.g. john",
  "egAbc123": "e.g. abc123",
  "egCaliforniaOntario": "e.g. California, Ontario",
  "egLosAngelesToronto": "e.g. Los Angeles, Toronto",
  "eg1000081921681024": "e.g. 10.0.0.0/8, 192.168.1.0/24",
  "media": "Media",
  "egHDHomeRunAntennaCable": "e.g. HDHomeRun, Antenna, Cable",
  "announcementSentCount": "Announcement sent. Sessions: {{count}}",
  "nameDetail": "Name: {{value}}",
  "urlDetail": "URL: {{value}}",
  "sourceDetail": "Source: {{value}}",
  "pathDetail": "Path: {{value}}",
  "deviceIdDetail": "Device ID: {{value}}",
  "userAgentDetail": "User agent: {{value}}",
  "tunerDetails": "Type: {{type}}\nID: {{id}}\n{{details}}",
  "serverLogDirectories": "Emby uses logs; Jellyfin uses log.",
  "transcodeLogDirectory": "Directory containing ffmpeg transcode logs for enhanced media type classification.",
  "fileCount": "Files: {{count}}",
  "directoryCount": "Directories: {{count}}",
  "streamsInUse": "Streams in use: {{count}}",
  "noActiveStreams": "No active streams",
  "channelCount": "Channels: {{count}}",
  "selectedTuners": "Selected tuners: {{count}}",
  "tunerCount": "Tuners: {{count}}",
  "maxCharacters": "Maximum {{count}} characters",
  "seenAt": "Seen {{time}}",
  "iptvbossGuide": "IPTVBoss Live TV Guide",
  "iptvbossGuideDescription": "Adds Now / Next / Upcoming programme data to Live TV channel pages in the Media Portal, read from the IPTVBoss XMLTV export. Works for Emby, Jellyfin and Plex. Automatic when IPTVBoss is installed and an XMLTV output is enabled in its editor.",
  "noExportYet": "No export",
  "notInstalled": "Not installed",
  "showGuideInMediaPortal": "Show guide in Media Portal",
  "nowNextUpcomingOnLiveTVChannelPages": "Now / Next / Upcoming on Live TV channel pages",
  "guideStatusLine": "{{channels}} channels, {{programmes}} programmes, updated {{updated}}",
  "guideStatusLineNoTime": "{{channels}} channels, {{programmes}} programmes",
  "noXMLTVExportFoundYet": "No XMLTV export found yet",
  "liveTvAnalytics": "Live TV analytics",
  "liveTvAnalyticsDescription": "Records what plays on each Live TV channel as programme segments, so Live TV appears in Top Titles and Trending with real per-programme completion. Programme data is captured from the moment this is on; earlier Live TV history has none.",
  "enableLiveTvAnalytics": "Capture Live TV programme analytics",
  "addsLiveTvToTopTitlesAndTrending": "Adds Live TV programmes to Top Titles and Trending",
  "liveTvAnalyticsStatus": "{{providers}} detected, {{segments}} programme segments captured",
  "connectionLabel": "Label",
  "sourcePrimary": "Primary",
  "sourceAdded": "Added",
  "sourceDetected": "Detected on this server",
  "statusOk": "Connected",
  "statusForbidden": "Refused",
  "statusUnreachable": "Unreachable",
  "statusDisabled": "Disabled",
  "statusPending": "Not checked yet",
  "connectionCounts": "{{channels}} channels, {{programmes}} programmes",
  "connectionUpdated": "updated {{updated}}",
  "dispatcharrForbiddenHelp": "Dispatcharr refused this server. In Dispatcharr, open Settings > Network Access and add this server's IP under M3U / EPG Endpoints.",
  "dispatcharrGuideOnlyWithoutKey": "Guide only. Add an API key for live channel details on Plex.",
  "aPIKeySaved": "Saved",
  "clearStoredKey": "Clear stored key",
  "storedKeyWillBeCleared": "The stored key will be cleared on save.",
  "hideAPIKey": "Hide API key",
  "revealAPIKey": "Reveal API key",
  "connectionTestResult": "EPG {{epg}}, M3U {{m3u}}, API {{api}}",
  "reachable": "reachable",
  "notReachable": "not reachable",
  "apiOk": "ok",
  "apiUnauthorized": "unauthorized",
  "apiNotProvided": "no key",
  "apiUnreachable": "unreachable",
  "testConnection": "Test",
  "removeConnection": "Remove",
  "addConnection": "Add connection",
  "saveConnections": "Save connections",
  "loadingDispatcharrConnections": "Loading connections",
  "noDispatcharrConnectionsYet": "No Dispatcharr connections yet.",
  "couldNotLoadDispatcharrConnections": "Could not load Dispatcharr connections.",
  "couldNotSaveDispatcharrConnections": "Could not save Dispatcharr connections.",
  "couldNotTestDispatcharrConnection": "Could not test the Dispatcharr connection."
} as const;
